import { render, staticRenderFns } from "./EstadoNovedades.vue?vue&type=template&id=19ad4e1f&scoped=true"
import script from "./EstadoNovedades.vue?vue&type=script&lang=js"
export * from "./EstadoNovedades.vue?vue&type=script&lang=js"
import style0 from "./EstadoNovedades.vue?vue&type=style&index=0&id=19ad4e1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ad4e1f",
  null
  
)

export default component.exports